module.exports = __webpack_public_path__ + "img/shops.9ccd708f.svg";